import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const queryParams = new URLSearchParams(window.location.search);
const tenantId = queryParams.get("tenantId");

if (tenantId) {
  sessionStorage.setItem("tenantId", tenantId);
  sessionStorage.setItem("sso_redirect", "true");

  // ✅ Save where the user actually wanted to go
  const intendedPath =
    window.location.pathname +
    window.location.search
      .replace(/[?&]tenantId=[^&]*/g, "")
      .replace(/^&/, "?");
  sessionStorage.setItem("sso_redirect_to", intendedPath || "/dashboard");

  window.history.replaceState(null, "", window.location.pathname);
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
